import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { tarifasAdminApi } from '@/data/api/tarifasAdminApi';
const KEY = 'tarifas-admin';
export function useTarifasAdmin(sucursalId, opts) {
    return useQuery({
        queryKey: [KEY, sucursalId, opts?.activo ?? 'default'],
        queryFn: () => tarifasAdminApi.listar(sucursalId, opts),
        enabled: Boolean(sucursalId),
    });
}
export function useCrearTarifa(sucursalId) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (v) => tarifasAdminApi.crear(sucursalId, v),
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: [KEY] });
            qc.invalidateQueries({ queryKey: ['catalogo', 'tarifas'] });
        },
    });
}
export function useEditarTarifa() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ id, values }) => tarifasAdminApi.editar(id, values),
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: [KEY] });
            qc.invalidateQueries({ queryKey: ['catalogo', 'tarifas'] });
        },
    });
}
export function useCerrarTarifa() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ id, hasta }) => tarifasAdminApi.cerrar(id, hasta),
        onSuccess: () => qc.invalidateQueries({ queryKey: [KEY] }),
    });
}
export function useDesactivarTarifa() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (id) => tarifasAdminApi.desactivar(id),
        onSuccess: () => qc.invalidateQueries({ queryKey: [KEY] }),
    });
}
